__turbopack_context__.v({
  "root": "SatributePill-module__g01Pea__root",
});
